export enum Dislikes {
  Clippers = 'Clippers',
  EarsTouched = 'EarsTouched',
  FeetTouched = 'FeetTouched',
  Pokes = 'Pokes',
  SoundSensitivity = 'SoundSensitivity',
}
